import * as coreClient from "@azure/core-client";

export interface VoucherCodeApplyRequest {
  /** UUID Generated Unique for Each Basket */
  basketId: string;
  /** Voucher Code To Be Applied for Discount */
  voucherCode: string;
}

export interface VoucherCodeApplyResponse {
  /** UUID Generated Unique for Each Basket */
  basketId: string;
  basketItems: VoucherCodeBasketItem[];
  discount: BasketDiscount;
}

export interface VoucherCodeBasketItem {
  /** Ticket Product ID */
  ticketID: number;
  /** Ticket Description based on Ticket ID */
  ticketDescription?: string;
  /** Price of Basket Item with Quantity as 1 */
  itemPrice: number;
  /** Quantity of Basket Item */
  quantity: number;
  /** Total Price of Basket Item - Item Price multiply with provided Quanity */
  subTotalPrice: number;
}

export interface BasketDiscount {
  /** Voucher Code To Be Applied for Discount */
  voucherCode: string;
  /** Total Discount Value To be Applied As Discount considering All Products in Cart (Basket) */
  totalDiscountValue: number;
  /** Discount Label to be Used for Display (will be received from Talon response) */
  discountLabel: string;
  accepted?: VoucherCodeDiscountAccepted[];
  /** Failure Reason when Voucher Code is Invalid or Discount is Not Applied due to Some Reason (will be received from Talon response) (Please Check Error Response Google Sheet To Match with TalonOne Responses) */
  discountRejectedReason?: BasketDiscountRejectedReason;
}

export interface VoucherCodeDiscountAccepted {
  /** Ticket Product ID */
  ticketID: number;
  /** Discount Value To be Applied As Discount On Product (will be received from Talon response) as 1.75 - 10% discount per Item Price * quantity */
  discountValue: number;
}

export interface ApiError {
  code?: number;
  shortDescription?: string;
  description?: string;
}

export interface VoucherCodeRemoveResponse {
  /** Success Message after Voucher Code is Removed */
  message?: string;
}

export interface CustomerLoginNotificationResponse {
  /** Success Message after Customer Login is Notified for Discount Session */
  message?: string;
}

/** Known values of {@link HostOptions} that the service accepts. */
export enum KnownHostOptions {
  /** host: https:\//nxbus.api.nationalexpress.com */
  HttpsNxbusApiNationalexpressCom = "https://nxbus.api.nationalexpress.com",
  /** host: https:\//perfnxbus.api.nationalexpress.com */
  HttpsPerfnxbusApiNationalexpressCom = "https://perfnxbus.api.nationalexpress.com",
  /** host: https:\//dt8nxbus.api.nationalexpress.com */
  HttpsDt8NxbusApiNationalexpressCom = "https://dt8nxbus.api.nationalexpress.com",
  /** host: https:\//dt6nxbus.api.nationalexpress.com */
  HttpsDt6NxbusApiNationalexpressCom = "https://dt6nxbus.api.nationalexpress.com"
}

/**
 * Defines values for HostOptions. \
 * {@link KnownHostOptions} can be used interchangeably with HostOptions,
 *  this enum contains the known values that the service supports.
 * ### Known values supported by the service
 * **https:\//nxbus.api.nationalexpress.com**: host: https:\/\/nxbus.api.nationalexpress.com \
 * **https:\//perfnxbus.api.nationalexpress.com**: host: https:\/\/perfnxbus.api.nationalexpress.com \
 * **https:\//dt8nxbus.api.nationalexpress.com**: host: https:\/\/dt8nxbus.api.nationalexpress.com \
 * **https:\//dt6nxbus.api.nationalexpress.com**: host: https:\/\/dt6nxbus.api.nationalexpress.com
 */
export type HostOptions = string;

/** Known values of {@link BasketDiscountRejectedReason} that the service accepts. */
export enum KnownBasketDiscountRejectedReason {
  /** VoucherCodeCustomerTypedTextIsNotValidPleaseCheckYourCodeForCouponNotFound */
  VoucherCodeCustomerTypedTextIsNotValidPleaseCheckYourCodeForCouponNotFound = 'Voucher code "customer typed text" is not valid. Please check your code. - #(For CouponNotFound)',
  /** VoucherCodeCustomerTypedTextHasAlreadyBeenRedeemedForCouponLimitReached */
  VoucherCodeCustomerTypedTextHasAlreadyBeenRedeemedForCouponLimitReached = 'Voucher code "customer typed text" has already been redeemed. - #(For CouponLimitReached)',
  /** VoucherCodeCustomerTypedTextCouldNotBeAppliedToThisJourneyPleaseCheckTheVoucherCodeCriteriaForCouponRejectedByCondition */
  VoucherCodeCustomerTypedTextCouldNotBeAppliedToThisJourneyPleaseCheckTheVoucherCodeCriteriaForCouponRejectedByCondition = 'Voucher code "customer typed text" could not be applied to this journey. Please check the voucher code criteria. - #(For CouponRejectedByCondition)',
  /** ManyMore */
  ManyMore = "..many more.."
}

/**
 * Defines values for BasketDiscountRejectedReason. \
 * {@link KnownBasketDiscountRejectedReason} can be used interchangeably with BasketDiscountRejectedReason,
 *  this enum contains the known values that the service supports.
 * ### Known values supported by the service
 * **Voucher code "customer typed text" is not valid. Please check your code. - #(For CouponNotFound)** \
 * **Voucher code "customer typed text" has already been redeemed. - #(For CouponLimitReached)** \
 * **Voucher code "customer typed text" could not be applied to this journey. Please check the voucher code criteria. - #(For CouponRejectedByCondition)** \
 * **..many more..**
 */
export type BasketDiscountRejectedReason = string;

/** Optional parameters. */
export interface ApplyVoucherCodeOptionalParams
  extends coreClient.OperationOptions {
  /** Apply Voucher Code on the Basket - Validate If Voucher Code is Applicable from Talon.One */
  body?: VoucherCodeApplyRequest;
}

/** Contains response data for the applyVoucherCode operation. */
export type ApplyVoucherCodeResponse = VoucherCodeApplyResponse;

/** Optional parameters. */
export interface RemoveVoucherCodeOptionalParams
  extends coreClient.OperationOptions {}

/** Contains response data for the removeVoucherCode operation. */
export type RemoveVoucherCodeResponse = VoucherCodeRemoveResponse;

/** Optional parameters. */
export interface CustomerLoginNotifyDiscountOnBasketOptionalParams
  extends coreClient.OperationOptions {}

/** Contains response data for the customerLoginNotifyDiscountOnBasket operation. */
export type CustomerLoginNotifyDiscountOnBasketResponse = CustomerLoginNotificationResponse;

/** Optional parameters. */
export interface DiscountAPIOptionalParams
  extends coreClient.ServiceClientOptions {
  /** server parameter */
  $host?: HostOptions;
  /** Overrides client endpoint. */
  endpoint?: string;
}
